
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface CostItemProps {
  label: string;
  amount: number;
  icon?: React.ReactNode;
  highlight?: boolean;
}

const CostItem: React.FC<CostItemProps> = ({ 
  label, 
  amount, 
  icon, 
  highlight = false 
}) => (
  <div className={`flex items-center justify-between py-2 ${highlight ? 'font-semibold text-lg' : ''}`}>
    <div className="flex items-center gap-2">
      {icon && <span className="text-primary">{icon}</span>}
      <span>{label}</span>
    </div>
    <span className={highlight ? 'text-primary font-bold' : ''}>
      ${amount.toLocaleString()}
    </span>
  </div>
);

export default CostItem;
